import { render, staticRenderFns } from "./CountdownSection.vue?vue&type=template&id=61fcf5c2&scoped=true"
import script from "./CountdownSection.vue?vue&type=script&lang=ts"
export * from "./CountdownSection.vue?vue&type=script&lang=ts"
import style0 from "./CountdownSection.vue?vue&type=style&index=0&id=61fcf5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fcf5c2",
  null
  
)

export default component.exports